module.exports = __webpack_public_path__ + "img/PSB.734f401e.svg";